module.exports = __webpack_public_path__ + "static/media/81680030-5SF0wSgs.8e207a0d.JPG";